<template>
  <div class="inAndOutStoreList">
    <sirui-search
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @companyChange="companyChange"
      @periodChange="periodChange"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    >
    </sirui-search>
    <div class="main-content inAndOut">
      <el-row>
        <el-col :span="2">
          <div class="grid-content bg-purple-dark">
            {{ this.$t('inAndOutStore.column.projectName') }}
          </div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple-dark">
            <el-input v-model="projectNameShow" :disabled="true"> </el-input>
          </div>
        </el-col>
        <el-col :span="2">
          <div class="grid-content bg-purple-dark">
            {{ this.$t('inAndOutStore.column.reportDate') }}
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content bg-purple-dark">
            <el-input v-model="reportDateShow" :disabled="true"> </el-input>
          </div>
        </el-col>
      </el-row>
      <vxe-toolbar
        v-if="menuButtonList.length > 0"
        ref="VxeToolbar"
        :data="tableData"
        size="mini"
        :id="$route.path"
      >
        <template v-slot:buttons>
          <template v-for="(item, i) in menuButtonList">
            <vxe-button
              v-if="item.type == '0'"
              type="primary"
              :icon="item.attributes.buttonStyle"
              :key="i"
              @click="chooseClick(item.attributes.buttonUrl, item)"
              >{{ item.label }}</vxe-button
            >
          </template>
        </template>
      </vxe-toolbar>
      <vxe-grid
        border
        show-overflow
        resizable
        ref="siruiTable"
        class="vxe-table-element"
        size="mini"
        align="left"
        :auto-resize="true"
        :data="tableData"
        :columns="columnList"
        column-min-width="120"
        :loading="load"
        show-footer
        highlight-current-row
        :header-cell-class-name="headerCellClassName"
        :footer-method="footerMethod"
        @handleSelectionChange="handleSelectionChange"
        max-height="73%"
      >
      </vxe-grid>
    </div>
    <sirui-upload :action="action" ref="SiruiUpload" :data="token"></sirui-upload>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import API from '@/api/productCenter/inAndOutStore';
  import siruiUpload from '@/components/SiruiUpload';
  import SiruiSearch from '@/components/SiruiSearch';
  import DataBaseAPI from '@/api/dataBase';
  import { dateFormat } from '@/filters';
  import XEUtils from 'xe-utils';
  import baseUrl from '@/common/config';
  export default {
    name: 'inAndOutStoreList',
    components: {
      SiruiSearch,
      siruiUpload,
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      token() {
        return {
          access_token: this.userInfo.access_token,
          companyCode: this.userInfo.companyCode,
          companyName: this.userInfo.companyName,
          departmentCode: this.userInfo.departmentCode,
          departmentName: this.userInfo.departmentName,
          tenantCode: this.userInfo.tenantCode,
        };
      },
      baseUrl() {
        return baseUrl;
      },
      // 搜索栏表格展示字段
      searchColumns() {
        return [
          {
            // 公司
            prop: 'businessCompanyCode',
            name: this.$t('inAndOutStore.column.businessCompanyName'),
            type: 'select',
            options: this.companyList,
            changeMethod: 'companyChange',
            filterable: true,
          },
          {
            // 业务部门
            prop: 'businessDepartmentCode',
            name: this.$t('inAndOutStore.column.businessDepartmentName'),
            type: 'select',
            options: this.departmentList,
            filterable: true,
          },
          {
            // 账期
            prop: 'periodName',
            name: this.$t('inAndOutStore.column.periodName'),
            type: 'searchTableSpec',
            searchType: 'pdPeriod',
            isMultiple: true,
            extraData: {
              projectCode: this.query.projectCode,
            },
            currentValue: this.query.periodName,
            changeMethod: 'periodChange',
          },
          {
            // 项目名称
            prop: 'projectCode',
            name: this.$t('inAndOutStore.column.projectName'),
            type: 'dict',
            dictType: 'produce_product_proname',
            disabled: true,
          },
          /* { // 开始日期
          prop: "reportDateStart", 
          name: this.$t('inAndOutStore.column.reportDateStart'), 
          type: "startDaterangePicker",
          required: true
        },
        { // 结束日期
          prop: "reportDateEnd", 
          name: this.$t('inAndOutStore.column.reportDateEnd'), 
          type: "endDaterangePicker",
        }, */
        ];
      },
      columnList() {
        return [
          // { type: "checkbox", width: "50", fixed: "left" }, // 复选框
          //序号
          {
            type: 'seq',
            title: this.$t('inAndOutStore.table.sortNo'),
            width: 80,
            fixed: 'left',
          },
          //公司名称
          {
            field: 'businessCompanyName',
            title: this.$t('inAndOutStore.column.businessCompanyName'),
          },
          //部门名称
          {
            field: 'businessDepartmentName',
            title: this.$t('inAndOutStore.column.businessDepartmentName'),
          },
          //账期名称
          { field: 'periodName', title: this.$t('inAndOutStore.column.periodName') },
          //项目名称
          { field: 'projectName', title: this.$t('inAndOutStore.column.projectName') },
          //商品名称
          { field: 'productName', title: this.$t('inAndOutStore.column.productName') },
          //规格型号
          { field: 'productSpec', title: this.$t('inAndOutStore.column.productSpec') },
          //商品编码
          { field: 'productCode', title: this.$t('inAndOutStore.column.productCode') },

          {
            // 期初
            title: this.$t('inAndOutStore.column.opening'),
            headerAlign: 'center',
            children: [
              {
                field: 'openingCount',
                title: this.$t('inAndOutStore.column.openingCount'),
                headerAlign: 'center',
              }, // 数量（KG）
              {
                field: 'openingAmountWithoutTax',
                title: this.$t('inAndOutStore.column.openingAmountWithoutTax'),
                headerAlign: 'center',
              }, // 不含税金额（￥）
            ],
          },
          {
            // 本期
            title: this.$t('inAndOutStore.column.current'),
            headerAlign: 'center',
            children: [
              {
                field: 'currentInboundCount',
                title: this.$t('inAndOutStore.column.currentInboundCount'),
                headerAlign: 'center',
              }, // 入库数
              /* { field: 'currentTotalInboundCount', title: this.$t('inAndOutStore.column.currentTotalInboundCount'), headerAlign: 'center' }, // 累计生产入库 */
              {
                field: 'currentCostPrice',
                title: this.$t('inAndOutStore.column.currentCostPrice'),
                headerAlign: 'center',
              }, // 入库成本
              /* { field: 'currentTotalCostAmount', title: this.$t('inAndOutStore.column.currentTotalCostAmount'), headerAlign: 'center' }, // 累计生产成本 */
              {
                field: 'currentAvgPrice',
                title: this.$t('inAndOutStore.column.currentAvgPrice'),
                headerAlign: 'center',
              }, // 单位加权平均成本
              {
                field: 'daySalesCount',
                title: this.$t('inAndOutStore.column.daySalesCount'),
                headerAlign: 'center',
              }, // 销售数量
              /* { field: 'totalSalesCount', title: this.$t('inAndOutStore.column.totalSalesCount'), headerAlign: 'center' }, // 累计销售数量 */
              {
                field: 'daySalesCostAmount',
                title: this.$t('inAndOutStore.column.daySalesCostAmount'),
                headerAlign: 'center',
              }, // 销售成本
              /* { field: 'totalSalesCostAmount', title: this.$t('inAndOutStore.column.totalSalesCostAmount'), headerAlign: 'center' }, // 累计销售成本 */
            ],
          },
          {
            // 期末
            title: this.$t('inAndOutStore.column.end'),
            headerAlign: 'center',
            children: [
              {
                field: 'endCount',
                title: this.$t('inAndOutStore.column.endCount'),
                headerAlign: 'center',
              }, // 数量（KG）
              {
                field: 'endAmountWithoutTax',
                title: this.$t('inAndOutStore.column.endAmountWithoutTax'),
                headerAlign: 'center',
              }, // 不含税金额（￥）
            ],
          },
        ];
      },
    },
    data() {
      return {
        action: API.LIST_INANDOUTSTORE_IMPORT,
        multipleSelection: [],
        menuButtonList: [],
        tableData: [],
        load: false,
        query: {
          businessCompanyCode: null,
          businessDepartmentCode: null,
          periodCode: null,
          periodName: null,
          //projectCode: null, // 项目名称
          reportDateStart: null, // 开始日期
          reportDateEnd: null, // 结束日期
        },
        projectNameShow: null,
        reportDateShow: null,
        companyList: [],
        departmentList: [],
      };
    },
    mounted() {
      //this.getData();
      this.getCompany();
      this.getButtonList();
    },
    methods: {
      // 获取列表数据
      async getData() {
        if (!this.query.businessDepartmentCode) {
          return this.tips('noBusinessDepartmentCode', 'error');
        }
        if (!this.query.periodName) {
          return this.tips('noPeriodName', 'error');
        }
        this.projectNameShow = this.$baseRequest.getDictValueByType(
          'produce_product_proname',
          this.query.projectCode
        );
        this.reportDateShow =
          this.query.reportDateStart +
          (this.query.reportDateEnd ? '~' + this.query.reportDateEnd : '');
        this.load = true;
        let res = await this.$axios.post(API.LIST_INANDOUTSTORE_BY_PAGE, { ...this.query });
        if (res) {
          this.load = false;
          if (res.data.code === 0) {
            this.tableData = res.data.data;
          } else {
            this.$alert(res.data.msg);
          }
        }
      },
      /* getData() {
      this.load = true;
      this.$axios.post(API.LIST_INANDOUTSTORE_BY_PAGE, {...this.query}).then(res => {
        this.load = false;
				if(res.data.code === 0) {
					this.tableData = res.data.data.records;
					this.$refs.siruiTable.setPageTotal(res.data.data.total);
        } else {
          this.$alert(res.data.msg)
        }
			})
    }, */
      periodChange(val) {
        // 切换期间
        let res = val.val;
        if (res && res.length > 0) {
          this.query.periodCode = res[0].periodCode;
          this.query.periodName = res[0].periodName;
          this.query.projectCode = res[0].projectCode;
          this.query.projectName = res[0].projectName;
          this.query.reportDateStart = res[0].startDate;
          this.query.reportDateEnd = res[0].endDate;
        } else {
          this.query.periodCode = this.query.periodName = null;
          this.query.projectCode = this.query.projectName = null;
          this.query.reportDateStart = this.query.reportDateEnd = null;
        }
      },
      async getCompany() {
        // 公司
        let params = {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
        };
        const selectStatus = await this.$axios.post(DataBaseAPI.GET_PERSON_API, params);
        if (selectStatus.data.code == 0) {
          this.companyList = selectStatus.data.data.personCompanyInfo.map((item) => {
            return {
              value: item.personCompanyCode,
              label: item.personCompanyName,
            };
          });
        }
      },
      async getDepartment(companyCode) {
        // 取一级部门的最后一级部门
        if (companyCode) {
          let params = {
            id: this.userInfo.userCode,
            userCode: this.userInfo.userCode,
            personName: this.userInfo.userName,
            personCompanyCode: companyCode,
          };
          const selectStatus = await this.$axios.post(DataBaseAPI.GET_PERSON_API, params);
          if (selectStatus.data.code == 0) {
            this.departmentList = selectStatus.data.data.personDepartmentInfo.map((item) => {
              return {
                value: item.personDepartmentCode,
                label: item.personDepartmentName,
              };
            });
          }
        } else {
          this.departmentList = [];
        }
      },
      companyChange(val) {
        // 切换公司
        this.query.businessDepartmentCode = null;
        this.getDepartment(val.val);
      },
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e;
        });
      },
      searchBtnClick() {
        this.$refs.siruiTable.clearCheckboxReserve();
        this.getData();
      },
      resetBtnClick() {
        this.$refs.siruiTable.clearCheckboxReserve();
        this.getData();
      },
      handleSelectionChange(row) {
        this.multipleSelection = row;
      },
      footerMethod({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return this.$t('xTable.total');
            }
            if (
              [
                'openingCount',
                'openingAmountWithoutTax',
                'currentInboundCount',
                'currentTotalInboundCount',
                'currentCostPrice',
                'currentTotalCostAmount',
                'currentAvgPrice',
                'daySalesCount',
                'totalSalesCount',
                'daySalesCostAmount',
                'totalSalesCostAmount',
                'endCount',
                'endAmountWithoutTax',
              ].includes(column.property)
            ) {
              let subtrahend = 0;
              for (let i = 0; i < data.length; i++) {
                subtrahend = this.$cal.calCommon(data[i][column.property], subtrahend, '+');
              }
              return subtrahend;
            }
            return null;
          }),
        ];
      },
      // 按钮
      chooseClick(type) {
        if (type == 'del') {
          // 删除
          this.handleDel();
        } else if (type == 'exportData') {
          // 导出
          this.handleExport();
        } else if (type == 'getNewData') {
          // 最新情况
          this.getNewData();
        } else if (type == 'import') {
          // 导入
          this.handleImport();
        }
      },
      //最新情况
      getNewData() {
        this.query.reportDateStart = dateFormat(new Date());
        this.query.reportDateEnd = dateFormat(new Date());
        this.getData();
      },
      headerCellClassName() {
        return 'headerCellClassName';
      },
      handleImport() {
        // 导入
        this.$refs.SiruiUpload.openDialog(true);
      },
      handleExport() {
        // 导出
        if (this.tableData.length == 0) {
          return this.$message({
            showClose: true,
            message: this.$t('message.noExport'),
            type: 'error',
          });
        }
        const selectedList = this.$refs.siruiTable.getCheckboxReserveRecords(); // 历史选中数据
        let changeList = this.multipleSelection.concat(selectedList);
        if (changeList.length > 0) {
          let str = '';
          // let ids = changeList.forEach((item) => {
          //   str += 'idList=' + item.id + '&';
          // });
          window.location.href = `${this.baseUrl}${API.LIST_INANDOUTSTORE_EXPORT}?${str}access_token=${this.token.access_token}`;
        } else {
          const params = XEUtils.serialize(this.query);
          window.location.href = `${this.baseUrl}${API.LIST_INANDOUTSTORE_EXPORT}?${params}&access_token=${this.token.access_token}`;
        }
      },
      // 删除
      handleDel() {
        if (this.multipleSelection.length == 0) {
          return this.tips('pleaseSelectOne', 'error');
        }
        // let items = this.multipleSelection.map((i) => i.id);
        this.$confirmAction(this.$t('confirm.delete'))
          .then(() => {
            this.$axios.post(API.DELETE_SETTLESUMMARY, {}).then((res) => {
              if (0 == res.data.code) {
                this.$message({ showClose: true, message: res.data.msg, type: 'success' });
                this.resetBtnClick();
              } else {
                this.$alert(res.data.msg);
              }
            });
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      // 提示
      tips(info, type) {
        this.$message({
          showClose: true,
          message: this.$t(`inAndOutStore.message.${info}`),
          type: type,
        });
      },
      // 跳转路径
      toPath(name, query) {
        let path = {
          path: `/production/${name}`,
          name: name,
          meta: {
            keepAlive: true,
          },
          query: query,
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
    },
  };
</script>
<style scoped>
  .el-row {
    margin-bottom: 10px;
    font-size: 12px;
    text-align: right;
    vertical-align: middle;
    color: #606266;
  }
  .el-col {
    border-radius: 4px;
    line-height: 32px;
  }
  .grid-content {
    padding: 0 12px 0 0 !important;
  }
  .vxe-table-element >>> .vxe-header--column.headerCellClassName {
    background-color: #6299fe7a !important;
  }
</style>
